import { withStyles } from '@material-ui/styles';
import React from 'react';

import styles from '../styles/accountCell';

const AccountCell = ({ data, classes }) => {
  const { account } = data;
  return (
    <div className={classes.root}>
      <div>{account.name}</div>
      <div className={classes.accountNo}>{account.accountNo}</div>
    </div>
  );
};

export default withStyles(styles)(AccountCell);
